module.exports = {"name":"campaign","menu":{"label":"Campanhas","items":[{"label":"Enviar campanhas","route":"/enviar-mensagens","weight":1},{"label":"Campanhas","route":"/campanhas","weight":2}],"parent":"menuEngagement","weight":7}}


//////////////////
// WEBPACK FOOTER
// ./_source/javascripts/modules/campaign/config.json
// module id = 385
// module chunks = 0